import { render } from "./CheckFailed.vue?vue&type=template&id=44fd1a96"
import script from "./CheckFailed.vue?vue&type=script&lang=js"
export * from "./CheckFailed.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__